import * as React from "react";
import { SVGProps, memo } from "react";
const SvgEllipse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={4}
    height={4}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <circle cx={2} cy={2} r={2} fill="#BFBFBF" />
  </svg>
);
const Memo = memo(SvgEllipse);
export default Memo;
